// AdminHomePage/adminhomepage.js
import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import AdminSidebar from '../AdminSidebar/adminsidebar';
import AdminReport from '../AdminContent/adminreport';
import AdminUsers from '../AdminContent/adminusers';
import AdminSettings from '../AdminContent/adminsettings';
import AdminHome from '../AdminContent/adminhome';
import AdminUpgrade from '../AdminContent/adminupgrade';


const AdminHomePage = () => {
    const [activePage, setActivePage] = useState('dashboard');

    const renderContent = () => {
        switch (activePage) {
            case 'dashboard':
                return <AdminHome />;
            case 'reports':
                return <AdminReport />;
            case 'users':
                return <AdminUsers />;
            case 'settings':
                return <AdminSettings />;
                case 'upgrade':
                    return <AdminUpgrade />;    
            default:
                return <AdminHome />;
        }
    };

    return (
        <Container fluid className="p-0">
            <Row className="m-0">
                <Col xs={2} className="p-0">
                    <AdminSidebar activePage={activePage} setActivePage={setActivePage} />
                </Col>
                <Col xs={10} className="p-4">
                    {renderContent()}
                </Col>
            </Row>
        </Container>
    );
};

export default AdminHomePage;